import React from "react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProjectCard = ({ project, isAdmin, username }) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      const token = localStorage.getItem("token");
      const userEmail = localStorage.getItem("userEmail");
      if (!token || !userEmail || !project?.id) return;

      const response = await fetch(`${BACKEND_URL}/projects/${project.id}/admin-view`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();

      if (response.ok && data.isAdmin) {
        navigate(`/projects/${project.id}/admin-view`);
        return;
      }

      const membershipResponse = await fetch(
        `${BACKEND_URL}/projects/${project.id}/members/${userEmail}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const membershipData = await membershipResponse.json();

      if (membershipResponse.ok && membershipData.isTeamMember) {
        navigate(`/projects/${project.id}/collaborate`);
      } else {
        navigate(`/projects/${project.id}/details`);
      }
    } catch (error) {
      console.error("❌ Failed project navigation:", error);
      navigate(`/projects/${project.id}/details`);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="relative group cursor-pointer rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition transform hover:-translate-y-1 bg-white"
    >
      {/* Project Image */}
      <img
        src={project.image || "https://via.placeholder.com/600x400"}
        alt={project.title}
        onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/600x400")}
        className="w-full h-48 object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3">
        <h3 className="text-white font-semibold text-base truncate">{project.title}</h3>
      </div>
    </div>
  );
};

export default ProjectCard;
